import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { AppMainComponent } from '../../../../app.main.component';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ConfigurationService } from 'src/app/configurations/configurationService';
import { ConfirmationService, MessageService } from 'primeng/api';
import { DatePipe, TitleCasePipe } from '@angular/common';
import data from '../../staticJSON/inventory-template.json';
import { ObjectNames, Severity,Answer} from '../../constants/constants';

@Component({
  selector: 'app-type',
  templateUrl: './type.component.html',
  styleUrls: ['./type.component.scss'],
  providers: [ConfirmationService, DatePipe]
})
export class TypeComponent implements OnChanges {

  @Input() typesList = [];
  @Input() typeConfig: any;
  displayEditInventoryChannel: boolean = false;
  displayAddInventoryChannel: boolean = false;
  inventoryTypeForm: FormGroup;
  isInventoryChannelDisabled: boolean = false;
  inventoryTypeConfig;
  inventoryTypeTemplateConfig;
  allInventoryTypeJSON;
  allInventoryTypeTemplateJSON;
  allInventoryTypes = [];
  allInventoryStages = [];
  allInventoryTemplates = [];
  statusDisabled: boolean = false;
  answertypeConstants= Answer;
  templateInventoryTemp = data;

  constructor(private service: ConfigurationService, private messageService: MessageService,private titlecasePipe: TitleCasePipe) { }


    ngOnChanges(changes: SimpleChanges): void {
      if(changes?.typesList?.currentValue){
        this.typesList = changes?.typesList?.currentValue;
      }
      if(changes?.typeConfig?.currentValue){
        this.typeConfig = changes?.typeConfig?.currentValue;
      }
    }
  

  loadConfigurations(moduleName) {
    this.service.getConfigurationByModuleName(moduleName).subscribe(configs => {
      this.typeConfig = configs.filter(s => s.name == ObjectNames.productConstants.Inventory_Types_Object)[0];
      this.typesList = JSON.parse(this.typeConfig.configurationDetails[0].configJSONValue);
      this.isInventoryChannelDisabled = false;
    });
  }

  eventCalled(pipe) {
    if (pipe.isDefault) {
      this.typesList.forEach(element => {
        if (element.id != pipe.id) {
          element.isDefault = false;
        }
      });
      this.updateInventoryType(pipe);
    }
  }

  updateInventoryType(c) {
    this.isInventoryChannelDisabled = true;
    this.typesList.forEach(element => {
      if (c.id == element.id) {
        element.name = c.name,
        element.isActive = c.isActive;
        element.isDefault = c.isDefault;
        element.updatedDate = new Date().toISOString();
      }

    });
    this.typeConfig.configJSONValue = JSON.stringify(this.typesList);
    this.service.updateConfiguration(this.typeConfig).then(() => {
      this.messageService.add({ severity: Severity.Success, summary: this.titlecasePipe.transform(Severity.Success), detail: 'Type updated successfully...' });
      this.loadConfigurations('product');
    }).catch(() => {
      this.isInventoryChannelDisabled = false;
      this.messageService.add({ severity: Severity.Error, summary: this.titlecasePipe.transform(Severity.Error), detail: 'Error occurred while saving data...' });
    });
    this.displayEditInventoryChannel = false;
  }

}
